<template>
  <div>
    <span class="link"
          @click="toggleDropdown"
    >
      <slot name="link"></slot>
    </span>
    <transition name="modalfadein" mode="in-out">
      <span class="dropdown" v-show="show">
        <slot name="content"></slot>
      </span>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'Dropdown',
    data() {
      return {
        show: false
      }
    },
    methods: {
      toggleDropdown(e) {
        this.show = !this.show
        let event = 'close'
        if (this.show) {
          event = 'open'
        }
        this.$emit(event)
      },
      close(e) {
        if (this.show && !this.$el.contains(e.target)) {
          this.show = false
          this.$emit('close')
        }
      }
    },
    mounted() {
      document.addEventListener('click', this.close)
    },
    beforeDestroy() {
      document.removeEventListener('click', this.close)
    }
  }
</script>

<style scoped lang="sass">
.link
  cursor: pointer
.dropdown
  z-index: 999999
.modalfadein-enter-active, .modalfadein-leave-active
  transition: opacity .2s, transform .2s ease
.modalfadein-enter, .modalfadein-leave-to
  opacity: 0
  transform: translateY(.5rem)
</style>
